import { DashboardCustomizationContext } from "@dashboard/contexts/dashboardCustomizationContext";
import { useContext } from "react";

export function useDashboardCustomization() {
    const context = useContext(DashboardCustomizationContext);

    if (!context) {
        throw new Error(
            "useDashboardCustomization must be used within DashboardCustomizationProvider.",
        );
    }

    return context;
}
